import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertBannerModule } from '../alert-banner/alert-banner.module';
import { SharedModule } from '../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    AlertBannerModule,
    HomeRoutingModule,
    SharedModule,
    CommonModule
  ]
})
export class HomeModule {
}
